import angular from "angular";

export default angular.module("input.decimal", [])
// to be used on input type="text"
.directive('formatDecimal', function($filter) {
    return {
        restrict:'A',
        require: 'ngModel',
        link: function(scope, element, attrs, ngModelController) {
            ngModelController.$parsers.push(function(input) {
                var ret=(input)?input.toString().trim().replace(/\ /g,"").replace(/\,/g,"."):null;
                if(ret === null) return null;
                return parseFloat(ret);
            });
            var format = function(value) {
                if(value === null || value === undefined || value === "") return "";
                var str;
                if(attrs.formatDecimal > 0){
                    str = parseFloat(value).toFixed(attrs.formatDecimal).replace(".",",");
                }else if(attrs.formatDecimal == 0){
                    str = parseInt(value,10);
                }else{
                    str = parseFloat(value).toString().replace(".",",");
                }
                var parts = str.toString().split(",");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(",");
            };
            ngModelController.$formatters.push(format);
            
            element.on('blur', function(){
                ngModelController.$setViewValue(format(ngModelController.$modelValue));
                ngModelController.$render();
            });
        }
    };
})
.name;


// WEBPACK FOOTER //
// ./src/decimal/index.js